/**
 * Raw API fields are typically `Type | null` (a GraphQL/REST response includes a selected field,
 * using null when it doesn't apply); this package's own shared types use `Type | undefined`
 * throughout, so this normalizes at that boundary.
 */
export function orUndefined<T>(value: T | null | undefined): T | undefined {
  return value ?? undefined;
}
